import clsx from 'clsx';
import type { ProgressBarProps } from './interfaces';
import styles from './ProgressBar.module.scss';

const ProgressBar = ({
  progress,
  visible,
  withBackground,
  className,
}: ProgressBarProps) => {
  return (
    <div className={clsx({ [styles.withBackground]: withBackground })}>
      <div
        className={clsx(styles.base, className)}
        style={{
          transform: `scaleX(${progress / 100}) scaleY(${visible ? 1 : 0})`,
        }}
      />
    </div>
  );
};

export default ProgressBar;
